package com.klantenstop.web.pages.admin.moderation

import com.klantenstop.web.data.models.domain.ModerationEntry
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationEntityType
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationEntryDetailDto
import com.klantenstop.web.utils.MVI

interface ModerationQueueContract : MVI<ModerationQueueContract.State, ModerationQueueContract.Intent, ModerationQueueContract.Effect> {

    data class State(
        val items: List<ModerationEntry> = emptyList(),
        val total: Long = 0,
        val page: Int = 1,
        val pageSize: Int = 20,
        val isLoading: Boolean = false,
        val error: String? = null,
        val expandedRowId: String? = null,
        val entryDetailCache: Map<String, ModerationEntryDetailDto> = emptyMap(), // entryId -> detail DTO
        val loadingEntryIds: Set<String> = emptySet(), // Track which entries are currently loading details
        val snapshotErrorByEntryId: Map<String, String> = emptyMap(), // entryId -> error message
        val rejectDialogEntryId: String? = null,
    )

    sealed class Intent {
        data class LoadQueue(val entityType: ModerationEntityType?, val page: Int) : Intent()
        data class ChangePage(val newPage: Int) : Intent()
        data class ToggleRow(val entryId: String) : Intent()
        data class ApproveEntry(val entryId: String) : Intent()
        data class ShowRejectDialog(val entryId: String) : Intent()
        data object HideRejectDialog : Intent()
        data class RejectEntry(val entryId: String, val reason: String) : Intent()
    }

    sealed class Effect {
        data class ShowSuccess(val message: String) : Effect()
        data class ShowError(val message: String) : Effect()
    }
}

